import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  SUBMIT_FORM,
  SHIFT_GET_DATA,
  SUBMIT_BULK_DELETE,
  SUBMIT_DELETE,
  SHIFT_EDIT_SUBMIT_FORM,
} from "constants/doctorShift.constants";
import axios from "axios";
import {
  setStatusDoctorShiftCreate,
  getShiftsSuccess,
  onSubmitShiftEditSuccess,
  onChangeEditStatus,
} from "actions/doctorShift.action";
import { showErrors, stopLoader, setNotification } from "actions/general.action";
import moment from "moment";

// create doctor shift
const createDoctorShiftRequest = async (doctor_shift_data) => {
  const {
    shift_date_range,
    shift_type,
    shift_doctors,
    shift_categories,
    shift_payment_type,
    auto_toggle_in_on_that_time,
    auto_toggle_out_on_that_time,
    shift_gp,
    shift_non_gp,
  } = doctor_shift_data;

  let new_shift_date_range = [
    moment(shift_date_range[0]).format("YYYY-MM-DDTHH:mm:ss"),
    moment(shift_date_range[1]).format("YYYY-MM-DDTHH:mm:ss"),
  ];
  //   create doctors id array
  let doctors = [];
  shift_doctors.map((doctor) => {
    doctors.push(doctor.id);
  });
  //   create shift categories id array
  let shiftCategories = [];
  shift_categories.map((shift_category) => {
    shiftCategories.push(shift_category.id);
  });
  //   create Object data
  const shiftDataObject = {
    date_range: new_shift_date_range,
    doctors: doctors,
    shift_data: shift_type === "gp" ? shift_gp : shift_non_gp,
    shift_categories: shiftCategories,
    payment_type: shift_payment_type === "per_shift" ? 0 : 1,
    auto_toggle_in_on_time: auto_toggle_in_on_that_time,
    auto_toggle_out_on_time: auto_toggle_out_on_that_time,
  };
  return axios.post("/api/v1/super_admin/doctor_shifts", shiftDataObject);
};

function* createDoctorShift({ shift_data }) {
  let notification = {
    open: true,
    status: "",
    message: "",
  };
  try {
    const result = yield call(createDoctorShiftRequest, shift_data);
    if (result.data.data.msg === "Request Success") {
      notification.status = "success";
      notification.message = "Doctor Shift created";
      yield all([put(setStatusDoctorShiftCreate(true)), put(stopLoader())]);
    } else {
      notification.status = "error";
      notification.message = "Request Failed";
      yield put(stopLoader());
    }
    yield put(setNotification(notification));
  } catch (error) {
    notification.status = "error";
    notification.message = error.message;
    yield put(stopLoader());
    yield put(setNotification(notification));
  }
}

// get doctor shifts
const fetchDoctorShiftsRequest = async (page, searchDataObject) => {
  let link = "/api/v1/super_admin/doctor_shifts?group_by=shift_category_id";
  if (searchDataObject) {
    let { search_type } = searchDataObject;
    if (search_type === "doctor_id" || search_type === "doctor_name") {
      if (searchDataObject.search_by_doctor.length !== 0) {
        let doctors_id_array = [];
        searchDataObject.search_by_doctor.map((doctor) => {
          doctors_id_array.push(doctor.id);
        });
        let doctor_id = doctors_id_array.toString();
        if (page && page !== 0) {
          link = `/api/v1/super_admin/doctor_shifts?group_by=shift_category_id&page=${page}&doctor_id=${doctor_id}`;
        } else {
          link = `/api/v1/super_admin/doctor_shifts?group_by=shift_category_id&doctor_id=${doctor_id}`;
        }
      }
    }
    if (search_type === "shift_category") {
      if (searchDataObject.search_by_shift_category.length !== 0) {
        let shift_category_id_array = [];
        searchDataObject.search_by_shift_category.map((shift_category) => {
          shift_category_id_array.push(shift_category.id);
        });
        let shift_category_id = shift_category_id_array.toString();
        if (page && page !== 0) {
          link = `/api/v1/super_admin/doctor_shifts?group_by=shift_category_id&page=${page}&shift_category_id=${shift_category_id}`;
        } else {
          link = `/api/v1/super_admin/doctor_shifts?group_by=shift_category_id&shift_category_id=${shift_category_id}`;
        }
      }
    }
    if (search_type === "date_range") {
      if (
        searchDataObject.search_by_date_range[0] !== null &&
        searchDataObject.search_by_date_range[1] !== null
      ) {
        let start_date = moment(searchDataObject.search_by_date_range[0]).format("YYYY-MM-DD");
        let end_date = moment(searchDataObject.search_by_date_range[1]).format("YYYY-MM-DD");
        console.log(start_date, end_date);
        if (page && page !== 0) {
          link = `/api/v1/super_admin/doctor_shifts?group_by=shift_category_id&page=${page}&start_date=${start_date}&end_date=${end_date}`;
        } else {
          link = `/api/v1/super_admin/doctor_shifts?group_by=shift_category_id&start_date=${start_date}&end_date=${end_date}`;
        }
      }
    }
  } else {
    if (page && page !== 0) {
      link = `/api/v1/super_admin/doctor_shifts?group_by=shift_category_id&page=${page}`;
    }
  }
  return axios.get(link);
};

function* fetchDoctorShift({ page, searchDataObject }) {
  try {
    const result = yield call(fetchDoctorShiftsRequest, page, searchDataObject);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      yield all([put(getShiftsSuccess(result.data)), put(stopLoader("Doctor Shift Get"))]);
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

//update doctor shift
const updateShiftRequest = async (shift_data) => {
  const {
    id,
    doctor_id,
    start_time_date,
    end_time_date,
    payment_type,
    remark,
    auto_toggle_in_on_that_time,
    auto_toggle_out_on_that_time,
    shift_category_id,
  } = shift_data;

  const shiftObject = {
    doctor_id: doctor_id,
    start_time_date: moment(start_time_date).format("YYYY-MM-DDTHH:mm:ss"),
    end_time_date: moment(end_time_date).format("YYYY-MM-DDTHH:mm:ss"),
    payment_type: payment_type,
    remark: remark,
    auto_toggle_in_on_time: auto_toggle_in_on_that_time,
    auto_toggle_out_on_time: auto_toggle_out_on_that_time,
    shift_category_id: shift_category_id,
  };
  return axios.put("/api/v1/super_admin/doctor_shifts/" + id, shiftObject);
};

function* updateDoctorShift({ shift_data }) {
  try {
    const result = yield call(updateShiftRequest, shift_data);
    if (result.message) {
      let new_status = {
        open: true,
        status: "error",
        message: result.message,
      };
      yield all([put(showErrors(result.message)), put(onChangeEditStatus(new_status))]);
    } else {
      let new_status = {
        open: true,
        status: "success",
        message: "Doctor Shift Updated",
      };
      yield all([
        put(onSubmitShiftEditSuccess(result.data.data)),
        put(stopLoader("Doctor Shift Updated")),
        put(onChangeEditStatus(new_status)),
      ]);
    }
  } catch (error) {
    let new_status = {
      open: true,
      status: "error",
      message: error,
    };
    yield all([put(showErrors(error.message)), put(onChangeEditStatus(new_status))]);
  }
}

// bulk Delete DoctorShift
const bulkDeleteDoctorShiftsRequest = async (deleted_id_array) => {
  //   create Object for delete data
  const deletedIdArray = {
    deleteArray: deleted_id_array,
  };
  return axios({
    method: "delete",
    url: "/api/v1/super_admin/doctor_shifts/bulk_delete",
    data: deletedIdArray,
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

function* bulkDeleteDoctorShift({ deleted_id_array, searchDataObject, page }) {
  try {
    const result = yield call(bulkDeleteDoctorShiftsRequest, deleted_id_array);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      let resultCallAction = call(fetchDoctorShiftsRequest);
      if (
        searchDataObject &&
        searchDataObject.search_type !== "" &&
        searchDataObject.search_type !== "all_data"
      ) {
        resultCallAction = call(fetchDoctorShiftsRequest, page, searchDataObject);
      }
      const resultShifts = yield resultCallAction;
      if (resultShifts.message) {
        yield put(showErrors(resultShifts.message));
      }
      yield all([put(getShiftsSuccess(resultShifts.data)), put(stopLoader("Doctor Shift Get"))]);
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

// delete doctor shift
const deleteDoctorShiftRequest = async (delete_id) => {
  return axios({
    method: "delete",
    url: "/api/v1/super_admin/doctor_shifts/" + delete_id,
    headers: {
      'Content-Type': 'text/plain'
    },
    data: "",
  });
};

function* deleteDoctorShift({ delete_id, searchDataObject, page }) {
  try {
    const result = yield call(deleteDoctorShiftRequest, delete_id);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      let resultCallAction = call(fetchDoctorShiftsRequest);
      if (
        searchDataObject &&
        searchDataObject.search_type !== "" &&
        searchDataObject.search_type !== "all_data"
      ) {
        resultCallAction = call(fetchDoctorShiftsRequest, page, searchDataObject);
      }
      const resultShifts = yield resultCallAction;
      if (resultShifts.message) {
        yield put(showErrors(resultShifts.message));
      }
      yield all([put(getShiftsSuccess(resultShifts.data)), put(stopLoader("Doctor Shift Get"))]);
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

export function* forkCreateDoctorShift() {
  yield takeEvery(SUBMIT_FORM, createDoctorShift);
}

export function* forkFetchDoctorShifts() {
  yield takeEvery(SHIFT_GET_DATA, fetchDoctorShift);
}

export function* forkUpdateShift() {
  yield takeEvery(SHIFT_EDIT_SUBMIT_FORM, updateDoctorShift);
}

export function* forkBulkDeleteDoctorShifts() {
  yield takeEvery(SUBMIT_BULK_DELETE, bulkDeleteDoctorShift);
}

export function* forkDeleteDoctorShift() {
  yield takeEvery(SUBMIT_DELETE, deleteDoctorShift);
}

export default function* rootSaga() {
  yield all([
    fork(forkCreateDoctorShift),
    fork(forkFetchDoctorShifts),
    fork(forkUpdateShift),
    fork(forkBulkDeleteDoctorShifts),
    fork(forkDeleteDoctorShift),
  ]);
}
